import React from "react";

import LandingHeader from "../components/Header";
import LandingFooter from "../components/Footer";
import MobileBottomBar from "../../main/components/MobileBottomBar";

function Main() {
    return (
        <div className="def_background min-h-screen flex flex-col">
            <LandingHeader />

            <main className="max-w-[1200px] mx-auto px-4 pt-10 pb-20 lg:px-0 flex-1">
                <section className="mb-10">
                    <div className="bg-[#147F26] text-white rounded-2xl px-6 py-8 md:px-8 md:py-10">
                        <h1 className="text-2xl md:text-3xl font-bold leading-snug mb-4">
                            Создаём агро продукты для Казахстана, стран СНГ и Китая
                        </h1>
                        <p className="text-base md:text-lg leading-relaxed max-w-xl">
                            Наши продукты помогают миллионам людей эффективно управлять агробизнесом,
                            выращивать урожай, торговать сельхозпродукцией и находить надежных партнеров.
                        </p>
                    </div>
                </section>

                <section className="grid gap-6 mb-14 md:grid-cols-2 lg:grid-cols-3">
                    <article className="bg-[#147F26] text-white rounded-2xl px-5 py-7 flex flex-col justify-between">
                        <div>
                            <h3 className="text-xl font-bold mb-2">AgroX</h3>
                            <p className="text-sm leading-relaxed mb-5">
                                Платформа для цифрового управления агробизнесом
                            </p>
                        </div>
                        <button className="inline-flex items-center justify-center rounded-full bg-white text-[#147F26] text-sm font-medium px-5 py-2 shadow-sm hover:shadow-md transition">
                            Узнать о продукте
                        </button>
                    </article>

                    <article className="bg-[#7AB30E] text-[#222222] rounded-2xl px-5 py-7 flex flex-col justify-between">
                        <div>
                            <h3 className="text-xl font-bold mb-2">AgroTrade</h3>
                            <p className="text-sm leading-relaxed mb-5">
                                Маркетплейс для оптовой и розничной торговли продукцией
                            </p>
                        </div>
                        <button className="inline-flex items-center justify-center rounded-full bg-white text-[#147F26] text-sm font-medium px-5 py-2 shadow-sm hover:shadow-md transition">
                            Узнать о продукте
                        </button>
                    </article>

                    <article className="bg-[#147F26] text-white rounded-2xl px-5 py-7 flex flex-col justify-between">
                        <div>
                            <h3 className="text-xl font-bold mb-2">AgroMarket</h3>
                            <p className="text-sm leading-relaxed mb-5">
                                Онлайн‑витрина для фермеров, поставщиков и покупателей
                            </p>
                        </div>
                        <button className="inline-flex items-center justify-center rounded-full bg-white text-[#147F26] text-sm font-medium px-5 py-2 shadow-sm hover:shadow-md transition">
                            Узнать о продукте
                        </button>
                    </article>
                </section>

                <section>
                    <h2 className="text-2xl md:text-[28px] font-bold mb-3">Хроника</h2>
                    <div className="inline-flex items-center rounded-full bg-[#147F26] text-white px-5 py-1.5 text-sm font-semibold mb-6">
                        НАЧАЛО: 2024
                    </div>

                    <div className="relative">
                        <div className="absolute left-1/2 top-6 -translate-x-1/2 hidden lg:block h-[260px] w-px bg-[#d1d5db]" />

                        <div className="flex lg:grid lg:grid-cols-2 gap-4 overflow-x-auto pb-4 -mx-4 px-4 lg:mx-0 lg:px-0">
                            <article className="min-w-[260px] lg:min-w-0 bg-[#147F26] text-white rounded-2xl px-5 py-4 shadow-sm">
                                <h3 className="text-base font-semibold mb-2">Сентябрь</h3>
                                <p className="text-sm leading-relaxed">
                                    Изучение и анализ аналогичных проектов на аграрном рынке,
                                    формирование общей концепции Agroland.
                                </p>
                            </article>

                            <article className="min-w-[260px] lg:min-w-0 bg-[#147F26] text-white rounded-2xl px-5 py-4 shadow-sm">
                                <h3 className="text-base font-semibold mb-2">Октябрь</h3>
                                <p className="text-sm leading-relaxed">
                                    Составление первого технического задания и разработка
                                    архитектуры платформ AgroX, AgroTrade и AgroMarket.
                                </p>
                            </article>

                            <article className="min-w-[260px] lg:min-w-0 bg-[#147F26] text-white rounded-2xl px-5 py-4 shadow-sm">
                                <h3 className="text-base font-semibold mb-2">Ноябрь</h3>
                                <p className="text-sm leading-relaxed">
                                    Подготовка дизайна и начало разработки веб‑ и мобильного
                                    интерфейса, создание начального серверного API.
                                </p>
                            </article>

                            <article className="min-w-[260px] lg:min-w-0 bg-[#147F26] text-white rounded-2xl px-5 py-4 shadow-sm">
                                <h3 className="text-base font-semibold mb-2">Декабрь</h3>
                                <p className="text-sm leading-relaxed">
                                    Подготовка первого продукта, настройка CI/CD и запуск
                                    серверной части в рабочем состоянии.
                                </p>
                            </article>
                        </div>
                    </div>
                </section>
            </main>

            <LandingFooter />
            <MobileBottomBar />
        </div>
    );
}

export default Main;

